module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/text-1a0376.svg";